// Import Heroicons for navigation
import { 
  HomeIcon,
  CalendarDaysIcon,
  HeartIcon,
  ChatBubbleBottomCenterTextIcon,
  UserGroupIcon,
  PresentationChartBarIcon,
  ClipboardDocumentListIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  CalendarIcon,
  UserIcon,
  ShieldCheckIcon,
  UserGroupIcon as UsersIcon,
  DocumentCheckIcon,
  CogIcon,
  ChartBarIcon
} from '@heroicons/vue/24/outline'

// User roles constants
export const USER_ROLES = {
  ADMIN: 'admin',
  DOCTOR: 'doctor', 
  USER: 'user'
}

// Role permissions
export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: {
    canAccessAdmin: true,
    canManageUsers: true,
    canManageContent: true,
    canManageEvents: true,
    canViewAllData: true
  },
  [USER_ROLES.DOCTOR]: {
    canAccessDoctorPortal: true,
    canManagePatients: true,
    canCreateContent: true,
    canManageEvents: true,
    canViewPatientData: true
  },
  [USER_ROLES.USER]: {
    canAccessUserFeatures: true,
    canViewContent: true,
    canJoinEvents: true,
    canTrackHealth: true
  }
}

// Navigation items for each role
export const ROLE_NAVIGATION = {
  // When not logged in
  GUEST: [
    { name: 'Home', path: '/', icon: HomeIcon },
    { name: 'Events', path: '/events', icon: CalendarDaysIcon }
  ],
  
  // Regular user navigation
  [USER_ROLES.USER]: [
    { name: 'Home', path: '/', icon: HomeIcon },
    { name: 'Fitness', path: '/fitness', icon: HeartIcon },
    { name: 'Health Consultation', path: '/health-consultation', icon: ChatBubbleBottomCenterTextIcon },
    { name: 'Community', path: '/community', icon: UserGroupIcon },
    { name: 'Events', path: '/events', icon: CalendarDaysIcon }
  ],
  
  // Doctor navigation  
  [USER_ROLES.DOCTOR]: [
    { name: 'Doctor Dashboard', path: '/doctor', icon: PresentationChartBarIcon },
    { name: 'Patient Management', path: '/doctor/patients', icon: ClipboardDocumentListIcon },
    { name: 'Consultations', path: '/doctor/consultations', icon: ChatBubbleLeftRightIcon },
    { name: 'Content Creator', path: '/doctor/content', icon: DocumentTextIcon },
    { name: 'Event Management', path: '/doctor/events', icon: CalendarIcon },
    { name: 'Profile', path: '/doctor/profile', icon: UserIcon }
  ],
  
  // Admin navigation
  [USER_ROLES.ADMIN]: [
    { name: 'Admin Dashboard', path: '/admin', icon: ShieldCheckIcon },
    { name: 'User Management', path: '/admin/users', icon: UsersIcon },
    { name: 'Event Management', path: '/admin/events', icon: CalendarIcon },
    { name: 'Analytics', path: '/admin/analytics', icon: ChartBarIcon }
  ]
}

// Check if user has specific permission
export function hasPermission(userRole, permission) {
  if (!userRole || !ROLE_PERMISSIONS[userRole]) {
    return false
  }
  return ROLE_PERMISSIONS[userRole][permission] || false
}

// Get navigation items for user role
export function getNavigationForRole(userRole) {
  if (!userRole) {
    return ROLE_NAVIGATION.GUEST
  }
  return ROLE_NAVIGATION[userRole] || ROLE_NAVIGATION.GUEST
}